import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Button, message } from "antd";
import { updateEmployee } from "../../services/employeeService";

export const UpdateEmployeeModal = ({ visible, onCancel, onSuccess, initialValues, employeeId }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
  
    useEffect(() => {
      if (visible && initialValues) {
        form.setFieldsValue(initialValues);
      }
    }, [visible, initialValues, form]);
  
    const handleSubmit = async () => {
      try {
        const values = await form.validateFields();
        setLoading(true);
        
        const currentUserId = localStorage.getItem("userId");
        
        const employeeData = {
          ...values,
          updatedByUserId: currentUserId
        };
        
        await updateEmployee(employeeId, employeeData);
        message.success("Employee updated successfully");
        onSuccess();
      } catch (error) {
        if (error.errorFields) {
          // Form validation error
        } else {
          message.error("Failed to update employee");
          console.error("Error updating employee:", error);
        }
      } finally {
        setLoading(false);
      }
    };
  
    return (
      <Modal
        title="Bilgileri Düzenle"
        open={visible}
        onCancel={onCancel}
        footer={[
          <Button key="cancel" onClick={onCancel}>
            İptal
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={handleSubmit}
          >
            Güncelle
          </Button>,
        ]}
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            name: "",
            surname: "",
            phoneNumber: "",
          }}
        >
          <Form.Item
            name="name"
            label="İsim"
            rules={[
              { required: true, message: "İsim zorunludur" },
              { max: 100, message: "İsim 100 karakteri geçemez" },
            ]}
          >
            <Input />
          </Form.Item>
          
          <Form.Item
            name="surname"
            label="Soyisim"
            rules={[
              { required: true, message: "Soyisim zorunludur" },
              { max: 100, message: "Soyisim 100 karakteri geçemez" },
            ]}
          >
            <Input />
          </Form.Item>
          
          <Form.Item
            name="phoneNumber"
            label="Telefon Numarası"
            rules={[
              { pattern: /^\+?[0-9\-\s]+$/, message: "Telefon numarası formatı yanlış!" },
              { max: 20, message: "Telefon numarası 20 karakteri geçemez!" },
            ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    );
  };